import * as React from "react"

const CallUs = () => {
  const [open, setOpen] = React.useState(false)

  return (
    <div className="call-us m-show pos-rel">
      <a href="#" className="link" onClick={(e) => { e.preventDefault(); setOpen(!open) }}>
        <div className="call--icon with--icon">
          <div className="icon"></div>
        </div>
      </a>
      {open &&
        <div className="call-us--panel">
          <div className="call-us--item">
            <p className="uppercase small mb5">Brisbane</p>
            <a className="link" href="tel:+61733332858">+61 7 3333 2858</a>
          </div>
          <div className="call-us--item">
            <p className="uppercase small mb5">Sydney</p>
            <a className="link" href="tel:+61291919268">+61 2 9191 9268</a>
          </div>
        </div>
      }
    </div>
  )
}

export default CallUs
